import { render } from "./MyBuyRequests.vue?vue&type=template&id=89c54186&scoped=true"
import script from "./MyBuyRequests.vue?vue&type=script&lang=js"
export * from "./MyBuyRequests.vue?vue&type=script&lang=js"

import "./MyBuyRequests.vue?vue&type=style&index=0&id=89c54186&lang=css"
import "./MyBuyRequests.vue?vue&type=style&index=1&id=89c54186&lang=css"
import "./MyBuyRequests.vue?vue&type=style&index=2&id=89c54186&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89c54186"]])

export default __exports__